import styled from 'styled-components';
import { Card } from '../';
import { breakpoints } from '../../../stylesheets';

const AlertIconWrapper = styled(Card)`
  position: absolute;
  right: -20px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${breakpoints.sm}px) {
    right: 0;
  }
`;

export default AlertIconWrapper;
